import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';

import { CommonButton } from '@components/common/CommonButton';
import { CommonInput } from '@components/common/CommonInput';

type PromoCodeProps = {
  onPromoCodeApply: (value: string) => void;
  promoError: string | null;
};

export const PromoCodeInsertion = (props: PromoCodeProps) => {
  const { t } = useTranslation();
  const [promoCodeDraft, setPromoCodeDraft] = useState('');

  const handlePromoCodeApply = () => {
    props.onPromoCodeApply(promoCodeDraft.toUpperCase());
    setPromoCodeDraft('');
  };

  return (
    <div className="promo-code-insertion" data-testid="promo-code-insertion">
      <CommonInput
        label={t('cart.summary.promoCode.enterPromoCode')}
        onChange={(e) => setPromoCodeDraft(e.target.value)}
        value={promoCodeDraft.toUpperCase()}
        error={Boolean(props.promoError)}
        errorMessage={props.promoError}
      />
      <CommonButton
        data-testid="promo-code-insertion__apply-btn"
        type="tertiary_new"
        size="regular"
        className="text-button-1"
        onClick={() => handlePromoCodeApply()}
      >
        {t('cart.summary.promoCode.apply')}
      </CommonButton>
    </div>
  );
};
